angular.module('zc.projects')

.directive 'campaignGraph', (
  $filter,
  $location,
  $q,
  $translate,
  CampaignStats,
  Chart,
  Devise,
  SearchFilter,
  campaignGraphOptions,
  currencies,
  lib,
) ->
    restrict: 'E'
    require: '?filters'
    scope:
      project : '='
      campaign: '='
      filters : '='
      isAb: '='
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_graph.html'

    link: (scope, element, attrs) ->
      DEFAULT_DIMENSION = 'daily'
      DEFAULT_CHART_ITEM_VALUE = campaignGraphOptions[0].name

      scope.currency = currencies[scope.project.currency]
      scope.chartOptions = _.filter campaignGraphOptions, (option) ->
        if Devise.isMaster()
          return scope.isAb if option.name == 'cvr_increase_rate'
          return true
        if Devise.isInternalUser()
          return scope.isAb if option.name == 'cvr_increase_rate'
        return !option.isMasterOnly

      chartNames = _.map campaignGraphOptions, 'name'

      SearchFilter.setComponentDefaults('campaignGraph', {
        campaign_graph:
          default: DEFAULT_CHART_ITEM_VALUE
          keyProperty: 'name'
          getter: (name) ->
            _.find(scope.chartOptions, (d) -> d.name == name)
        campaign_graph_dimension:
          default: DEFAULT_DIMENSION
      })

      tooltip = (option) ->
        if option && option.name in ['average_conversion_price', 'conversion_price']
          return {
            valuePrefix: scope.currency.symbol,
            valueSuffix: scope.currency.suffix,
            valueDecimals: scope.currency.fractionSize,
          }

        return {
          valuePrefix: '',
          valueSuffix: scope.filters.campaign_graph_value.unit,
          valueDecimals: scope.filters.campaign_graph_value.decimal,
        }

      addSeries = ({
        color,
        data,
        name,
        option,
        yAxis,
      }) ->
        Chart.addSeries scope.chartConfig,
          color: color
          data: data
          name: name
          tooltip: tooltip(option)
          yAxis: yAxis

      scope.$on '$destroy', () ->
        SearchFilter.removeComponentDefaults('campaignGraph')

      scope.reset = ->
        # reset the search fields that this component is responsible of
        SearchFilter.resetComponentDefaults('campaignGraph')

      addYAxis = ({ option, isOpposite }) ->
        _tooltip = tooltip(option)
        scope.chartConfig.options.yAxis.push
          gridLineDashStyle: 'dot'
          min: 0
          labels:
            formatter: ->
              "#{_tooltip.valuePrefix}#{Highcharts.numberFormat(this.value, _tooltip.valueDecimals)}#{_tooltip.valueSuffix}"
          title:
            text: option.label
          opposite: isOpposite

      scope.updateGraphDropdown = (event, isAb) ->
        scope.isAb = isAb
        if scope.filters.campaign_graph_value.name == 'cvr_increase_rate'
          scope.filters.campaign_graph_value = campaignGraphOptions[0]
        scope.chartOptions = _.filter campaignGraphOptions, (option) ->
          if Devise.isMaster()
            return scope.isAb if option.name == 'cvr_increase_rate'
            return true
          if Devise.isInternalUser()
            return scope.isAb if option.name == 'cvr_increase_rate'
          return !option.isMasterOnly
        scope.updateData()

      scope.updateData = () ->
        SearchFilter.updateComponentDefaults('campaignGraph')

        # use valueOf below because this uses old V1 api
        if scope.filters.campaign_graph_dimension == 'cumulative_hourly'
          start_at = moment(scope.filters.start_at).subtract(1, 'hours').valueOf()
        else if scope.filters.campaign_graph_dimension == 'cumulative_daily'
          start_at = moment(scope.filters.start_at).subtract(1, 'days').valueOf()
        else
          start_at = moment(scope.filters.start_at).valueOf()

        CampaignStats.find
          dimension: scope.filters.campaign_graph_dimension
          campaign_id: scope.campaign.id
          apikey: scope.campaign.apikey
          start_at: start_at
          end_at: scope.filters.end_at
        .then (campaign_stats) ->
          scope.stats_for_chart = CampaignStats.forChart(campaign_stats, scope.filters.campaign_graph_dimension)
          control = []
          experiment = []

          for stats in scope.stats_for_chart
            stats.average_conversion_price = stats.average_conversion_price / (10 ** scope.currency.fractionSize)
            stats.conversion_price = stats.conversion_price / (10 ** scope.currency.fractionSize)
            if stats.is_control
              control.push stats
            else
              experiment.push stats

          control = $filter('zerosForMissingTime')(control, scope.filters.campaign_graph_dimension, {
            start_at: scope.filters.start_at,
            end_at: scope.filters.end_at
          })
          experiment = $filter('zerosForMissingTime')(experiment, scope.filters.campaign_graph_dimension, {
            start_at: scope.filters.start_at,
            end_at: scope.filters.end_at
          })

          # Recalculate cumulatives unless the campaign has started at same
          # moment (in which case we already have correct values and dont want
          # to subtract anything)
          if _.startsWith(scope.filters.campaign_graph_dimension, 'cumulative_') &&
              scope.filters.start_at != moment(scope.campaign.start_at).valueOf()

            [control, experiment] = _.map [control, experiment], (groupStats) ->
              groupStats = CampaignStats.calculateCumulatives(groupStats, start_at)

          # modify into proper format for chart
          field = scope.filters.campaign_graph_value.name
          field = 'conversion_rate' if field == 'cvr_increase_rate'
          control = _.map(control, (o) -> [o.start_at, o[field]])
          experiment = _.map(experiment, (o) -> [o.start_at, o[field]])

          options = if scope.isAb then {} else { options: { legend: false, colors: ['#26c9ff'] } }
          scope.chartConfig = Chart.getChartConfig 'line', options
          scope.chartConfig.series = []

          if scope.filters.campaign_graph_value.name == 'cvr_increase_rate'
            createChartForCVRIncreaseRate(experiment, control)
          else
            addSeries(
              name: $translate.instant('projectsCampaigns.directives.campaignGraph.displayGroup'),
              data: experiment
              option: scope.filters.campaign_graph_value,
            )
            addSeries(
              name: $translate.instant('projectsCampaigns.directives.campaignGraph.hiddenGroup'),
              data: control,
              option: scope.filters.campaign_graph_value,
            ) if scope.isAb

      createChartDataForCVRIncreaseRate = (experiment, control) ->
        return _.map experiment, ([start_at, experimental_conversion_rate], index) ->
          control_conversion_rate = if control[index] then control[index][1] else 0

          return [start_at, 0] unless control_conversion_rate
          return [start_at, (experimental_conversion_rate / control_conversion_rate) * 100]

      createChartForCVRIncreaseRate = (experiment, control) ->
        cvr_increase_rate = createChartDataForCVRIncreaseRate(experiment, control)
        conversion_rate_option = _.find(campaignGraphOptions, { name: 'conversion_rate' })

        addSeries(
          name: $translate.instant('sharedModules.commonApi.misc.campaignGraphOptions.cvrIncreaseRate')
          data: cvr_increase_rate
          option: scope.filters.campaign_graph_value
          yAxis: 0
          color: '#cccccc'
        )
        addSeries(
          name: $translate.instant('projectsCampaigns.directives.campaignGraph.displayGroupCVR')
          data: experiment
          option: conversion_rate_option
          yAxis: 1
          color: '#26c9ff'
        )
        addSeries(
          name: $translate.instant('projectsCampaigns.directives.campaignGraph.hiddenGroupCVR')
          data: control
          option: conversion_rate_option
          yAxis: 1
          color: '#666666'
        )

        scope.chartConfig.options.yAxis = []
        addYAxis({ option: scope.filters.campaign_graph_value, isOpposite: false })
        addYAxis({ option: conversion_rate_option, isOpposite: true })

      scope.updateData()
      scope.$on 'filtersUpdated', scope.updateData
      scope.$on 'filtersReset', scope.reset
      scope.$on 'isAbChanged', scope.updateGraphDropdown



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_graph.js.coffee